var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.9846 40.7214H21.0516",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9889 11.3713V28.1428V9.19098H48.9763L43.0224 30.3231C42.687 31.4132 41.7646 32.1679 40.5906 32.1679H9.98259C7.80229 32.1679 5.87357 33.7612 5.622 35.9415C5.37043 38.4572 7.38301 40.5537 9.81487 40.5537H11.492",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.0162 45.7529C44.795 45.7529 47.0477 43.5002 47.0477 40.7214C47.0477 37.9427 44.795 35.69 42.0162 35.69C39.2375 35.69 36.9848 37.9427 36.9848 40.7214C36.9848 43.5002 39.2375 45.7529 42.0162 45.7529Z",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0202 45.7528C18.799 45.7528 21.0517 43.5002 21.0517 40.7214C21.0517 37.9426 18.799 35.6899 16.0202 35.6899C13.2414 35.6899 10.9888 37.9426 10.9888 40.7214C10.9888 43.5002 13.2414 45.7528 16.0202 45.7528Z",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.47302 1.30841C9.8986 1.30841 10.9887 2.39856 10.9887 3.82413V11.3713",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.925903 1.30841H8.47307",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.198ea70909705c0d97535c1a55a1bcc6.svg";
export { ForwardRef as ReactComponent };